import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class CheckRoleGuardService implements CanActivate, CanActivateChild {
  private _userService = inject(UserService);
  router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const user = await this._userService.isLogged();
    if (!user) {
      return false;
    }
    const accessibleRoutes = this._userService.accessibleRoutes(user);
    if (accessibleRoutes.includes(route?.routeConfig?.path)) {
      return true;
    }
    const fallback = accessibleRoutes.find(Boolean);
    if (!fallback) {
      // The session grants nothing at all — a role the permission matrix has no entry for, or a
      // TRANSPORT_OPERATOR whose stored account carries no provider. There is no screen to fall
      // back to, so the session is over. (This used to scan for one with `arrPos = arrPos++`,
      // which never increments: on an empty list it span forever and hung the tab.)
      this._userService.logout();
      return false;
    }
    return this.router.navigate([fallback]);
  }

  canActivateChild(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return this.canActivate(null, null);
  }
}
